export default __webpack_public_path__ + "static/media/home-startup-business-process.65e987b2.jpg";